import styled from "styled-components";
import {ReactNode, useEffect, useState} from "react";


const OverlayStyle = styled.div<IOverlayProps>`
  position: absolute;
  top: 0;
  z-index: 9999999;
  background:  ${props => props.bg ?? 'rgba(255, 255, 255, 55%)'};
  right: 0;
  bottom: 0;
  left: 0;
  display: none;
  &.show {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
  }
`

interface IOverlayProps{
    className: string
    bg?: string
    children: ReactNode
}

export default function Overlay(props: IOverlayProps) {
    const [position, setPosition] = useState(0)
    useEffect(() => {
        if (props.className === 'show') {
            if (!document.body.classList.contains('block-height')) {
                document.body.classList.add('block-height')
                setPosition(window.scrollY)
                scrollTo(0, 0)
            }
        } else {
            if (document.body.classList.contains('block-height')) {
                document.body.classList.remove('block-height')
                scrollTo(0, position)
            }
        }
    }, [props.className,position]);

    return (
        <OverlayStyle style={{backgroundColor:props.bg}} className={props.className}>
            {props.children}
        </OverlayStyle>
    )
}